import React, { FunctionComponent } from "react";

import {
    AlignItems,
    FlexGrow,
    FontWeight,
    JustifyContent,
    Layout,
    Skeleton,
    SpacingSize,
    Text,
    TextColor,
} from "@multiweb/reactComponents";
import { createQA } from "@multiweb/reactUtils";
import { bemClassNames } from "@multiweb/reactUtils/bemClassNames";
import { QAProps } from "@multiweb/types/react";
import { AggregationResult, AggregationRowKey, ColumnKey, ColumnType } from "../../types";
import { AggregationSelect } from "../AggregationSelect";
import { CloseButton } from "../CloseButton";

export type ColumnComponentProps = {
    /** Šířka sloupce v pixelech. */
    width: number | undefined;
    /** Příznak, zda probíhá načítání výsledku agregační funkce. */
    isLoading: boolean;
    /** Typ sloupce. */
    columnType: ColumnType | undefined;
    /** Výsledek agregační funkce. */
    aggregationResult: AggregationResult | undefined;
    /** Klíč agregačního řádku. */
    aggregationRowKey: AggregationRowKey;
    /** Klíč sloupce. */
    columnKey: ColumnKey;
} & QAProps;

const classNames = bemClassNames("aggregation-row-column-component");

/**
 * Komponenta vykreslí sloupec agregačního řádku podle jeho typu.
 */
export const ColumnComponent: FunctionComponent<ColumnComponentProps> = ({
    width = 0,
    isLoading,
    columnType,
    aggregationResult,
    aggregationRowKey,
    columnKey,
    qa,
}) => (
    <div
        className={classNames()}
        style={{ width }}
        {...createQA(qa)}
    >
        {columnType === ColumnType.control && (
            <Layout flexGrow={FlexGrow.one} alignItems={AlignItems.center} justifyContent={JustifyContent.center} >
                <CloseButton {...{ aggregationRowKey }}/>
            </Layout>
        )}
        {columnType === ColumnType.numeric && (
            renderNumericColumn(aggregationRowKey, columnKey, aggregationResult, isLoading)
        )}
    </div>
);

const renderNumericColumn = (
    aggregationRowKey: AggregationRowKey,
    columnKey: ColumnKey,
    aggregationResult: AggregationResult | undefined,
    isLoading: boolean,
) => (
    <Layout flexGrow={FlexGrow.one} alignItems={AlignItems.center} justifyContent={JustifyContent.spaceBetween} spacingSizeRight={SpacingSize.xs} collapse={true}>
        <Layout flexGrow={FlexGrow.one}>
            <AggregationSelect {...{ aggregationRowKey, columnKey }} />
        </Layout>
        <Layout flexGrow={FlexGrow.one} collapse={true} justifyContent={JustifyContent.flexEnd}>
            {isLoading ? (
                <div className={classNames("loading")}>
                    <Skeleton/>
                </div>
            ) : (
                <div className={classNames("aggregation-result")}>
                    <Text
                        value={aggregationResult ?? ""}
                        title={aggregationResult ?? ""}
                        color={TextColor.textPrimary}
                        fontWeight={FontWeight.bold}
                    />
                </div>
            )}
        </Layout>
    </Layout>
);
